module.exports = __webpack_public_path__ + "static/media/loop_new.af361fa3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/sound/loop_new.mp3
// module id = 180
// module chunks = 0